import { defineMessages } from "react-intl";

export default defineMessages({
  Profile: { defaultMessage: "Profile", id: "itPgxd" },
  Relays: { defaultMessage: "Relays", id: "RoOyAh" },
  Owner: { defaultMessage: "Owner", id: "zINlao" },
  Software: { defaultMessage: "Software", id: "r3C4x/" },
  Contact: { defaultMessage: "Contact", id: "zFegDD" },
  Supports: { defaultMessage: "Supports", id: "hY4lzx" },
  Remove: { defaultMessage: "Remove", id: "G/yZLu" },
  Preferences: { defaultMessage: "Preferences", id: "PCSt5T" },
  Donate: { defaultMessage: "Donate", id: "2IFGap" },
  LogOut: { defaultMessage: "Log Out", id: "H0JBH6" },
  Theme: { defaultMessage: "Theme", id: "Pe0ogR" },
  System: { defaultMessage: "System (Default)", id: "P7FD0F" },
  Light: { defaultMessage: "Light", id: "3cc4Ct" },
  Dark: { defaultMessage: "Dark", id: "tOdNiY" },
  DefaultRootTab: { defaultMessage: "Default Page", id: "MWTx65" },
  Conversations: { defaultMessage: "Conversations", id: "1udzha" },
  Global: { defaultMessage: "Global", id: "EWyQH5" },
  AutoloadMedia: { defaultMessage: "Automatically load media", id: "xbVgIm" },
  AutoloadMediaHelp: {
    defaultMessage: "Media in notes will automatically be shown for selected people, otherwise only the link will show",
    id: "TDR5ge",
  },
  None: { defaultMessage: "None", id: "450Fty" },
  FollowsOnly: { defaultMessage: "Follows only", id: "odFwjL" },
  All: { defaultMessage: "All", id: "zQvVDJ" },
  ImgProxy: { defaultMessage: "Image proxy service", id: "ll3xBp" },
  ImgProxyHelp: { defaultMessage: "Use imgproxy to compress images", id: "4Z3t5i" },
  ServiceUrl: { defaultMessage: "Service URL", id: "YDURw6" },
  ServiceKey: { defaultMessage: "Key", id: "EcglP9" },
  ServiceSalt: { defaultMessage: "Salt", id: "GFOoEE" },
  EnableReactions: { defaultMessage: "Enable reactions", id: "YXA3AH" },
  EnableReactionsHelp: {
    defaultMessage: "Reactions will be shown on every page, if disabled no reactions will be shown",
    id: "PrsIg7",
  },
  ConfirmReposts: { defaultMessage: "Confirm Reposts", id: "89q5wc" },
  ConfirmRepostsHelp: { defaultMessage: "Reposts need to be manually confirmed", id: "uSV4Ti" },
  ShowLatest: { defaultMessage: "Automatically show latest notes", id: "zvCDao" },
  ShowLatestHelp: { defaultMessage: "Notes will stream in real time into global and notes tab", id: "a7TDNm" },
  FileUpload: { defaultMessage: "File upload service", id: "mKh2HS" },
  FileUploadHelp: { defaultMessage: "Pick which upload service you want to upload attachments to", id: "VOjC1i" },
  Default: { defaultMessage: "(Default)", id: "rfuMjE" },
  DebugMenus: { defaultMessage: "Debug Menus", id: "M3Oirc" },
  DebugMenusHelp: {
    defaultMessage: `Shows "Copy ID" and "Copy Event JSON" in the context menu on each message`,
    id: "MBAYRO",
  },
  EditProfile: { defaultMessage: "Edit Profile", id: "usAvMr" },
  About: { defaultMessage: "About", id: "g5pX+a" },
  LnAddress: { defaultMessage: "LN Address", id: "d7d0/x" },
  Avatar: { defaultMessage: "Avatar", id: "VnXp8Z" },
  Banner: { defaultMessage: "Banner", id: "25V4l1" },
  Edit: { defaultMessage: "Edit", id: "wEQDC6" },
  PrivateKey: { defaultMessage: "Your Private Key Is (do not share this with anyone)", id: "qdGuQo" },
  Add: { defaultMessage: "Add", id: "2/2yg+" },
  AddRelays: { defaultMessage: "Add Relays", id: "rT14Ow" },
  Name: { defaultMessage: "Name", id: "HAlOn1" },
  Website: { defaultMessage: "Website", id: "JkLHGw" },
  Save: { defaultMessage: "Save", id: "jvo0vs" },
  DisplayName: { defaultMessage: "Display name", id: "dOQCL8" },
  Buy: { defaultMessage: "Buy", id: "EnCOBJ" },
  Nip05: { defaultMessage: "NIP-05", id: "7hp70g" },
  ReactionEmoji: { defaultMessage: "Reaction emoji", id: "eHAneD" },
  ReactionEmojiHelp: { defaultMessage: "Emoji to send when reactiong to a note", id: "gDzDRs" },
  SocialGraph: { defaultMessage: "Social Graph", id: "CzHZoc" },
  HasWriteAccess: { defaultMessage: "Logged in with write access", id: "+UjDmN" },
  NoWriteAccess: { defaultMessage: "Logged in with read-only access", id: "bMphls" },
  NotificationsApiEnabled: { defaultMessage: "Notifications API Enabled", id: "5PRWs7" },
  NotificationsApiDisabled: { defaultMessage: "Notifications API Disabled", id: "qcJFEJ" },
  NotificationsAllowed: { defaultMessage: "Notifications Allowed", id: "nGGDsi" },
  NotificationsNotAllowed: { defaultMessage: "Notifications Not Allowed", id: "J1iLmb" },
  ServiceWorkerRunning: { defaultMessage: "Service Worker Running", id: "bG00/W" },
  ServiceWorkerNotRunning: { defaultMessage: "Service Worker Not Running", id: "RDha9y" },
  SubscribedToPush: { defaultMessage: "Subscribed to Push", id: "G3A56c" },
  NotSubscribedToPush: { defaultMessage: "Not Subscribed to Push", id: "d2ebEu" },
});
